import { createPortal } from 'react-dom';
import { useRootLayoutContext } from './RootLayoutContext';
export function Portal(props) {
    const element = useRootLayoutContext();
    if (element === null) {
        return null;
    }
    return createPortal(props.children, element);
}
//# sourceMappingURL=Portal.js.map